import React from 'react';

const REPO_URL = 'https://github.com/LPiDigitalLLC/printflow-aws';
const CHANGELOG_URL = 'https://github.com/LPiDigitalLLC/printflow-aws/blob/main/CHANGELOG.md';

const AboutTab: React.FC = () => (
  <div className="max-w-2xl">
    <div className="bg-white shadow rounded-lg p-8">
      {/* Logo */}
      <div className="flex justify-center mb-8">
        <img src="/logo.png" alt="PrintFlow" className="h-24" />
      </div>

      <h2 className="text-2xl font-semibold text-gray-900 text-center mb-1">PrintFlow</h2>
      <p className="text-sm text-gray-500 text-center mb-8">
        Serverless print job routing for LPi
      </p>

      {/* Links */}
      <div className="flex justify-center gap-6 mb-10">
        <a
          href={REPO_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm text-blue-600 hover:text-blue-800 hover:underline"
        >
          GitHub Repository
        </a>
        <span className="text-gray-300">|</span>
        <a
          href={CHANGELOG_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm text-blue-600 hover:text-blue-800 hover:underline"
        >
          Changelog
        </a>
      </div>

      {/* License */}
      <div className="border-t border-gray-200 pt-8">
        <p className="text-sm font-medium text-gray-700 mb-3">All Rights Reserved</p>
        <p className="text-sm text-gray-600 mb-4">
          Copyright &copy; 2025 LPi Digital, LLC
        </p>
        <p className="text-xs text-gray-500 leading-relaxed">
          THE SOFTWARE IS PROVIDED &ldquo;AS IS&rdquo;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
          IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
          FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
          AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
          LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
          OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
          THE SOFTWARE.
        </p>
      </div>
    </div>
  </div>
);

export default AboutTab;
